module.exports = __webpack_public_path__ + "media/white-label/typography-e5251427.png";